import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
export const cardBackgroundMap = {
    white: staticColors.cardWhiteBackground,
    grey: staticColors.cardGreyBackground,
    greyDark: staticColors.cardGreyDarkBackground,
    light: staticColors.cardActionLightBackground,
};
export const cardShadowMap = {
    white: `${sizes.card.boxShadowOffsetX} ${sizes.card.boxShadowOffsetY} ${sizes.card.boxShadowBlurRadius} ${staticColors.baseShadow}`,
    grey: 'none',
    greyDark: 'none',
    light: `${sizes.card.boxShadowOffsetX} ${sizes.card.boxShadowOffsetY} ${sizes.card.boxShadowBlurRadius} ${staticColors.baseShadow}`,
};
